import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FeedService } from './feed.service';
import { MaintananceService } from './maintanance.service'
import { EventService } from './event.service';

@Injectable()
export class PercentageIncreaseUpdaterService {

  private messageSource = new Subject();
  currentMessage = this.messageSource.asObservable();

  constructor(private feed: FeedService,
              private maintenance: MaintananceService,
              private eventService: EventService) { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  getUpdatedFeed(id, feedType, action = null): Observable<any>{
    console.log(id, feedType, "----------------------------");
    let data =  {id: id, feedType: feedType};
    this.messageSource.next(data);
    return this.messageSource;
  }

}
